import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
        <h2>Introduction</h2>
        <p>
        My name is Natalia and I’m a Licensed Massage Therapist in Utah. I’m very passionate about the art of healing and dedicated to wellness, I'm a goal-oriented massage therapist who finds joy in serving the community with empathy and a service-oriented work. I specialize in relaxation Swedish massage, to provide muscle tension & stress relief, aid with anxiety & depression and help with body maintenance.
        </p>
        <p>
        My expertise also extends to manual lymphatic drainage therapy, supporting post-op recovery and immune health. For those needing deeper relief, my sports massage and cupping techniques offer profound muscle release and rejuvenation. I'm committed to nurturing the body and spirit of each client, fostering well-being and balance.
        </p>
        <a
          href="https://g.co/kgs/pXWmeXt"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit Lunar Healing Bodywork & Massage
        </a>
      </Wrap> 
    </>
  );
};

export default Content;
